// extracted by mini-css-extract-plugin
module.exports = {"modal":"FullScreenModal_modal__J_0vd"};